import InfiniteCombobox from 'crono-fe-common/components/InfiniteCombobox';
import { List } from 'crono-fe-common/types/list';

interface SequenceListsFilterProps {
  selectedList: List | null;
  setSelectedList: (list: List | null) => void;
  //Fetched by the host: React Query in the app, IPC in the extension
  lists: List[];
  onSearchChange: (search: string) => void;
  fetchNextPage: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  isLoading?: boolean;
}

const SequenceListsFilter = ({
  selectedList,
  setSelectedList,
  lists,
  onSearchChange,
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
  isLoading,
}: SequenceListsFilterProps) => (
  <InfiniteCombobox<List>
    value={selectedList}
    onChange={setSelectedList}
    options={lists}
    getOptionKey={(list) => String(list.id)}
    getOptionLabel={(list) => list.name ?? ''}
    onSearchChange={onSearchChange}
    fetchNextPage={fetchNextPage}
    hasNextPage={hasNextPage}
    isFetchingNextPage={isFetchingNextPage}
    isLoading={isLoading}
    placeholder="Lists"
    empty="No lists found"
    dsSize="sm"
    //The picker renders inside MUI tooltips at z-index 35001/35002, and the
    //positioner isolates its own stacking context, so the lift has to go there
    positionerClassname="z-50000"
    //List names are far wider than the trigger, so the popup sizes to content
    contentClassName="w-auto min-w-55 max-w-80"
  />
);

export default SequenceListsFilter;
